module.exports = __webpack_public_path__ + "MuseoSans-700Italic.c3ad66cc7ac08442fae3.eot";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-700Italic.eot
// module id = ../../../../../src/assets/fonts/MuseoSans-700Italic.eot
// module chunks = styles